<template>
  <component :is="tag" :class="classAttr" v-tooltip:[arguments]="texto" >
    <slot name="content"></slot>
  </component>
</template>

<script>

export default {
  name:'ToolTip',
  props:{
    tag:{
      type:String,
      default:'i'
    },
    placement:{
      type:String,
      default:'top'
    },
    texto:{
      type:String,
      default:''
    },
    trigger:{
      type:String,
      default:'hover'
    },
    mostrar:{
      type:Boolean,
      default:false
    },
    popperConfig:{
      type:Object,
      default:null
    }
  },

  computed: {
    classAttr() {
      return this.$attrs.class || ''
    },

    arguments() {
      return {
        placement: this.placement,
        trigger: this.trigger,
        mostrar: this.mostrar,
        popperConfig: this.popperConfig
      }
    },
  },

  directives:{
    tooltip:{
      beforeMount(el, binding, vnode){
        $(el).tooltip({
          title: binding.value,
          placement: binding.arg.placement,
          trigger: binding.arg.trigger,
          popperConfig: binding.arg.popperConfig,
          html: true
        })

        $(el).on('show.bs.tooltip', function() {
          const customClass = $(el).data("custom-class")
          let $tooltip = $(this).data('bs.tooltip');

          if (customClass) {
            $($tooltip.$tip).addClass(customClass);
          }
        });
      },
      mounted(el, binding){
        if (binding.arg.trigger === 'manual' && binding.arg.mostrar) {
          $(el).tooltip('show')
        }
      },
      updated(el, binding){
        if (binding.arg.trigger !== 'manual') return

        $(el).tooltip(binding.arg.mostrar ? 'show' : 'hide')
      },
      unmounted(el) {
        try {
          $(el).tooltip('dispose');
        } catch (_) {
          // ignora: tooltip pode já ter sido destruído pelo Bootstrap quando o elemento sai do DOM
        }
      }
    }
  }
}
</script>
